// extracted by mini-css-extract-plugin
module.exports = {"root":"Header_root__2LN4o","name":"Header_name__28hZF","birthday":"Header_birthday__1Ir0M","skeleton":"Header_skeleton__3ancV"};